import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { LabeledCheckbox } from 'Blocks'
import { UrlBuilder } from 'Utils'

class MobileSortByView extends Component {
  static propTypes = {
    className: PropTypes.string,
    queryString: PropTypes.string
  }

  render() {
    const sortMatcher = this.props.queryString.match(/order=(\w+)/)

    const relevanceTo = (() => {
      const builder = new UrlBuilder(this.props.queryString)
      return builder.clearSort().getQueryString()
    })()

    const lowTo = (() => {
      const builder = new UrlBuilder(this.props.queryString)
      return builder.setSortOn('price').setSortDirection('asc').getQueryString()
    })()

    const highTo = (() => {
      const builder = new UrlBuilder(this.props.queryString)
      return builder
        .setSortOn('price')
        .setSortDirection('desc')
        .getQueryString()
    })()

    const relevanceProps = {
      label: 'Relevance',
      isSelected: !sortMatcher,
      className: !sortMatcher
        ? 'labeled-checkbox selected'
        : 'labeled-checkbox',
      to: relevanceTo
    }

    const isLowSelected = !!(sortMatcher && sortMatcher[1] === 'asc')
    const lowProps = {
      label: 'Price low to high',
      isSelected: isLowSelected,
      className: isLowSelected
        ? 'labeled-checkbox selected'
        : 'labeled-checkbox',
      to: lowTo
    }

    const isHighSelected = !!(sortMatcher && sortMatcher[1] === 'desc')
    const highProps = {
      label: 'Price high to low',
      isSelected: isHighSelected,
      className: isHighSelected
        ? 'labeled-checkbox selected'
        : 'labeled-checkbox',
      to: highTo
    }

    return (
      <div className="filter-panel__filter panel">
        <div className={`sorting-panel sorting ${this.props.className}`}>
          <LabeledCheckbox {...relevanceProps} />
          <LabeledCheckbox {...lowProps} />
          <LabeledCheckbox {...highProps} />
        </div>
      </div>
    )
  }
}

export default MobileSortByView
